import React from 'react';
import SEO from '../components/seo';
import Layout from '../components/Layout';
import { Box, Image, Heading, Text } from 'grommet';
import writingIllustration from '../images/illustrations/note_taking.svg';
import { getThemeColor } from '../theme';

const BlogPage = () => (
  <Layout>
    <SEO title="Bolg" />
    <Box
      justify="center"
      align="center"
      css={`
        min-height: 95vh;
      `}
      width="full"
      pad="large"
    >
      <Box width="xxlarge" justify="center" align="center" pad="large">
        <Box width="medium" responsive pad="small">
          <Image
            src={writingIllustration}
            fill="false"
            alt="Blog Illustration Image"
            a11yTitle="Blog Illustration Image"
          />
        </Box>
        <Box width="large">
          <Heading level="1" textAlign="center">
            Nothing here yet, but I'm working on it!
          </Heading>
          <Text
            textAlign="center"
            css={`
              color: ${getThemeColor('brand-gray')};
            `}
          >
            I know, I know, if you have a blog on your website, you should put
            something in there! I have couple of topics I'd like to cover here,
            so if you're interested in programming, smart home, home automation,
            IOT devices and some travelling as well, add this site to your
            bookmarks, because it's all coming! (pinky promise)
          </Text>
        </Box>
      </Box>
    </Box>
  </Layout>
);

export default BlogPage;
